const FreeIcon = ({ width = 18, color = '#000000' }) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="8.25" width="12" height="6.75" stroke={color} strokeWidth="1.5" />
    <rect x="3" y="4.5" width="12" height="3.75" stroke={color} strokeWidth="1.5" />
    <rect x="8.25" y="3.75" width="1.5" height="12" fill={color} />
    <path d="M6.375 1.875L9 4.5L11.625 1.875" stroke={color} strokeWidth="1.5" />
  </svg>
)
export default FreeIcon
